import angular from 'angular';
import RetailerReportsTabContentComponent from './retailer-reports-tab-content-component';

export default angular
  .module('retailer-reports-tab-component', [])
  .component('retailerReportsTabContent', new RetailerReportsTabContentComponent());



// WEBPACK FOOTER //
// ./src/modules/retailer-reports/components/retailer-reports-tab-content/retailer-reports-tab-content-module.js